import { render, staticRenderFns } from "./ImportModifiers.vue?vue&type=template&id=27c9748a&"
import script from "./ImportModifiers.vue?vue&type=script&lang=js&"
export * from "./ImportModifiers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports